import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUser } from 'services/users/duck';
import { push } from 'connected-react-router';
import ViewUser from 'components/organisms/user/ViewUser';
import UserTabView from 'components/organisms/user/UserTabView';

class ViewUserContainer extends Component {
    componentDidMount() {
        const id = this.props.match.params.id;

        if (this.props.fetchUser && id) {
            this.props.fetchUser({ id });
        }
    }

    render() {
        return (
            <UserTabView selected="info" currentUser={this.props.currentUser} user={this.props.user} push={this.props.push}>
                <ViewUser
                    user={this.props.user}
                    push={this.props.push}>
                    {this.props.children}
                </ViewUser>
            </UserTabView>
        );
    }
}

const mapStateToProps = state => ({
    user: state.users.user,
    currentUser: state.users.currentUser
});

export default connect(mapStateToProps, { fetchUser, push })(ViewUserContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/users/ViewUserContainer.js